import { func, string } from 'prop-types';
import { TimePicker } from 'ui-component-library';
import React from 'react';

/**
 * Input for providing time values.
 * @param {object} params - Contains the props for this component
 * @param {string} params.value - Value of input
 * @param {func} params.onValueChange - Handles when a user changes the inputs value
 * @return {element} - The TimeInput component.
 */
const TimeInput = ({ value, onValueChanged, id }) => {
  const handleChanged = (timeValue) => {
    onValueChanged({
      target: {
        value: timeValue,
      },
    });
  };

  return (
    <TimePicker
      id={`actualOpenTime_${id}`}
      name="actualDateOpenTime"
      type="time"
      selectedValue={value}
      onValueChange={handleChanged}
      placeHolder="Select..."
    />

  );
};

TimeInput.propTypes = {
  value: string,
  onValueChanged: func.isRequired,
  id: string,
};

TimeInput.defaultProps = {
  value: '',
  id: '',
};

export default TimeInput;
